function EmptyCard({message}:any) {
  return (
    <div className="px-5 py-2 mx-auto lg:px-32 lg:pt-24">
      <div className="grid content-center h-[36rem] grid-cols-1 gap-4 rounded bg-slate-100">
        <h3 className="flex flex-row justify-center">
          <span className="text-xl font-bold text-slate-600">{message}</span>
        </h3>
      </div>
    </div>
  );
}
export default EmptyCard;
